import React, { Component } from 'react';
import {
  Table, Input, Select, DatePicker,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import _, { map } from 'lodash';
import consts from '../consts';
import utils from '../common/utils';
import BigNumber from 'bignumber.js';
import moment from 'moment';
import 'moment/locale/vi';
import 'moment/locale/en-il';
import Search from 'antd/lib/input/Search';

const { Option } = Select;
const { RangePicker } = DatePicker;

const columns = [
  {
    title: 'ID',
    key: 'id',
    dataIndex: 'id',
    fixed: 'left',
    ellipsis: true,
  },
  {
    title: 'Tài khoản',
    dataIndex: 'pubkey',
    key: 'pubkey',
    fixed: 'left',
    ellipsis: true,
  },
  {
    width: 90,
    fixed: 'left',
    align: 'center',
    title: 'Đồng',
    dataIndex: 'currency',
    key: 'currency',
  },
  {
    align: 'center',
    title: 'Thời gian',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (timeStamp) => utils.formatTimeFromUnix(timeStamp, 'DD/MM/YYYY HH:mm')
  },
  {
    title: 'Địa chỉ gửi',
    dataIndex: 'from_address',
    key: 'from_address',
    ellipsis: true,
    // render: (fromAddr) => <div
    //   className='ellipsis'
    //   title={fromAddr}
    // >{fromAddr}</div>
  },
  {
    title: 'Địa chỉ nhận',
    dataIndex: 'to_address',
    key: 'to_address',
    ellipsis: true,
    // render: (toAddr) => <div
    //   className='ellipsis'
    //   title={toAddr}
    // >{toAddr}</div>
  },
  {
    align: 'center',
    width: 200,
    title: 'Số tiền giao dịch',
    dataIndex: 'amount',
    key: 'amount',
    render: (ignore, trans) => new BigNumber(trans.fee).plus(trans.amount)
      .toFormat(8)
  },
  {
    align: 'center',
    title: 'Phí giao dịch',
    dataIndex: 'fee',
    width: 110,
    key: 'fee',
    render: (fee) => <div>{utils.formatCurrency(fee) ?? 'Miễn phí'}</div>
  },
  {
    align: 'center',
    title: 'Số tiền nhận được',
    dataIndex: 'amount',
    key: 'amount',
    render: utils.formatCurrency,
  },
  {
    width: 90,
    fixed: 'right',
    align: 'center',
    title: 'Loại',
    dataIndex: 'type',
    key: 'type',
    render: (type) => <div style={{ color: type === 0 ? consts.COLOR_BUY : consts.COLOR_SELL }}>
      {utils.parseTransType(type)}
    </div>
  },
  {
    width: 110,
    fixed: 'right',
    align: 'center',
    title: 'Trạng thái',
    dataIndex: 'status',
    key: 'status',
    render: utils.parseTranStatus
  },
];

class TransactionHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCount: 0,
      isLoading: false,
      currentPage: 1,
      transSearch: undefined,
    };
    this.filter = {
      trans_type: consts.TYPE_ALL,
      currency: '',
      contract: '',
      trans_status: consts.TYPE_ALL,
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
      is_external: '',
    };
  }
  
  componentDidMount() {
    this.fetchData();
  }
  
  setTransType = (transType) => {
    this.filter.trans_type = transType;
    this.setState({ currentPage: 1, });
    this.fetchData();
  };
  
  setTransStatus = (transStatus) => {
    this.filter.trans_status = transStatus;
    this.setState({ currentPage: 1, });
    this.fetchData();
  };
  
  setCurrency = (currency) => {
    this.filter.currency = currency;
    this.setState({ currentPage: 1, });
    this.fetchData();
  };
  
  setTrade = (external) => {
    this.filter.is_external = external;
    this.setState({ currentPage: 1, });
    this.fetchData();
  };

  onChangeDate = (value) => {
    if (value !== null) {
      let start = value[0].startOf('day').toString();
      let dateEnd = value[1].endOf('day').toString();
      this.filter.begin = parseInt(moment(start).valueOf() / 1000);
      this.filter.end = parseInt(moment(dateEnd).valueOf() / 1000);
    } else {
      this.filter.begin = '';
      this.filter.end = '';
    }
    this.setState({ currentPage: 1, });
    this.fetchData();
  }
  
  fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE) => {
    this.setState({ isLoading: true });
    this.filter = {
      ...this.filter,
      pos,
      count,
    };
    this.props.onFetchTransactionFilterHistory(this.filter, this.updateTotalCount);
  };
  
  updateTotalCount = (totalCount) => {
    this.setState({
      totalCount,
      isLoading: false
    });
  };
  
  renderSelectCoins = () => {
    return map(this.props.coins || [], ({ symbol }) => <Option key={symbol} value={symbol}>
      {symbol}
    </Option>);
  };
  
  handleSearchTransaction = ({ currentTarget }) => {
    let transSearch = undefined;
    if (_.isEmpty(`${currentTarget.value}`)) {
      // utils.showNotification("Cảnh báo", "Không để trống mục tìm kiếm", consts.TYPE_WARNING);
      this.setState({ transSearch });
      return;
    }
    
    this.props.searchTransByIDAction({ id: currentTarget.value }, (transSearch) => {
      this.setState({ transSearch });
    });
  }

  render() {
    const { transSearch } = this.state;
    
    return (
      <div className="withdrawalHistory">
        <h2> Danh sách nạp rút </h2>
        <div className="transaction-history mt-medium mb-medium">
          <div>
            <span className="label"> Giao dịch:  </span>
            <Select defaultValue="-1" style={{
              width: 90,
              marginRight: 14
            }} onChange={this.setTransType}>
              <Option value="-1">Tất cả</Option>
              <Option value="0">Nạp</Option>
              <Option value="1">Rút</Option>
            </Select>
  
            <span className="label"> Trạng thái:  </span>
            <Select defaultValue="-1" style={{
              width: 140,
              marginRight: 14
            }} onChange={this.setTransStatus}>
              <Option value="-1">Tất cả</Option>
              <Option value="0">Thành công</Option>
              <Option value="1">Đang chờ xử lý</Option>
              <Option value="2">Đã gửi</Option>
              <Option value="3">Lỗi</Option>
              <Option value="4">Huỷ bỏ</Option>
            </Select>
  
            <span className="label"> Đồng:  </span>
            <Select className="select-currency" defaultValue="Tất cả" onChange={this.setCurrency}>
              <Option value="">Tất cả</Option>
              {this.renderSelectCoins()}
            </Select>
  
            <span style={{ marginRight: 8 }}> Giao dịch  </span>
            <Select className="select-trade" defaultValue="Tất cả" onChange={this.setTrade}>
              <Option value="">Tất cả</Option>
              <Option value={true}>Ngoài sàn</Option>
              <Option value={false}>Trong sàn</Option>
            </Select>
  
            <span className="label"> Thời gian  </span>
            <RangePicker
              locale={consts.LangDateVi}
              disabledDate={(current) => current && current > moment().endOf('day')}
              onChange={this.onChangeDate}
            />
          </div>
  
          <div>
            <Search onSearch={(value) => this.handleSearchTransaction({ currentTarget: { value } })}
                    placeholder={"Tìm kiếm theo ID"}
                    onPressEnter={this.handleSearchTransaction} />
          </div>
        </div>
        
        <Table columns={columns}
               dataSource={!!transSearch ? [transSearch] : this.props.trans || []}
              scroll={{x: 1480}}
               pagination={!!transSearch ? false : {
                 showQuickJumper: true,
                 defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                 current: this.state.currentPage,
                 showSizeChanger: false,
                 total: this.state.totalCount,
                 onChange: (page, pageSize) => {
                   this.fetchData((page - 1) * pageSize, pageSize);
                   this.setState({
                     currentPage: page,
                     isLoading: true
                   });
                 },
                 hideOnSinglePage: true,
                 responsive: true
               }} bordered
               loading={this.state.isLoading}
        />
      </div>
    );
  }
}

export default TransactionHistory;
